const STORAGE_KEY = 'silkreels.referral_code'

export function normalizeReferralCode(raw: string | null | undefined): string {
  return (raw ?? '').trim().toUpperCase()
}

/** 从 URL ?ref= 读取并持久化推荐码 */
export function captureReferralFromSearch(search: string): string {
  const code = normalizeReferralCode(new URLSearchParams(search).get('ref'))
  if (code) {
    try {
      localStorage.setItem(STORAGE_KEY, code)
    } catch {
      /* ignore */
    }
  }
  return code || getStoredReferralCode()
}

export function getStoredReferralCode(): string {
  try {
    return normalizeReferralCode(localStorage.getItem(STORAGE_KEY))
  } catch {
    return ''
  }
}

export function setStoredReferralCode(code: string): void {
  const normalized = normalizeReferralCode(code)
  try {
    if (normalized) localStorage.setItem(STORAGE_KEY, normalized)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
